import { defineAsyncComponent, markRaw } from 'vue'
import { getStatusLabel } from '@/utils'

export const todoModalTab = [
  {
    label: '处方',
    key: 1,
    ref: 'Prescription',
    list: 'prescriptionList',
    component: markRaw(
      defineAsyncComponent(() =>
        import('@/components/PatientFile/ModalBody/todo/components/Prescription.vue')
      )
    ),
    mode: 1
  },
  {
    label: '预病历',
    key: 2,
    ref: 'MedicalRecord',
    list: 'preMedicalRecordList',
    component: markRaw(
      defineAsyncComponent(() =>
        import('@/components/PatientFile/ModalBody/todo/components/MedicalRecord.vue')
      )
    ),
    mode: 1
  },
  {
    label: '复诊',
    key: 3,
    ref: 'FollowUpVisit',
    list: 'followupVisitList',
    component: markRaw(
      defineAsyncComponent(() =>
        import('@/components/PatientFile/ModalBody/todo/components/FollowUpVisit.vue')
      )
    ),
    mode: 1
  },
  {
    label: '随访管理',
    key: 4,
    ref: 'Visits',
    list: 'followupManageList',
    component: markRaw(
      defineAsyncComponent(() =>
        import('@/components/PatientFile/ModalBody/todo/components/Visits.vue')
      )
    ),
    mode: 1
  },
  {
    label: '平台相关',
    key: 5,
    ref: 'Platform',
    list: 'platformList',
    component: markRaw(
      defineAsyncComponent(() =>
        import('@/components/PatientFile/ModalBody/todo/components/Platform.vue')
      )
    ),
    mode: 1
  }
]

export const btnTextMap = {
  Prescription: '查看处方',
  MedicalRecord: '查看预病例',
  FollowUpVisit: '查看预约单',
  Visits: '查看量表'
}

// 处方表单
export const columnsToPrescription = [
  {
    title: '开具时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 180
  },
  {
    title: '开方医生',
    dataIndex: 'doctorName',
    key: 'doctorName',
    width: 100,
    slots: { customRender: 'doctorName' }
  },
  {
    title: '处方类型',
    dataIndex: 'prescriptionType',
    key: 'prescriptionType',
    width: 180
  },
  {
    title: '购买状态',
    dataIndex: 'purchaseStatus',
    key: 'purchaseStatus',
    width: 180
    // customRender: ({ record }) => {
    //   try {
    //     const { recommendStatus, recommendInvalid, expireStatus } = record || {}
    //     // const isExpire = moment(new Date()).isAfter(moment(recommendExpireAt))
    //     return getStatusLabel({
    //       status: recommendStatus,
    //       expire: expireStatus,
    //       invalid: recommendInvalid
    //     }).alt
    //   } catch (error) {
    //     return '--'
    //   }
    // }
  },
  {
    title: '已触达方式',
    dataIndex: 'touchWays',
    key: 'touchWays',
    width: 180
  },

  {
    title: '操作',
    width: 180,
    key: 'handle',
    dataIndex: 'handle',
    slots: { customRender: 'handle' },
    fixed: 'right'
  }
]

// 预病例表单
export const columnsToMedicalRecord = [
  {
    title: '创建预病历时间',
    dataIndex: 'createTime',
    key: 'createTime'
  },
  {
    title: '预病历发起人',
    dataIndex: 'operatorName',
    key: 'operatorName',
    slots: { customRender: 'operatorName' }
  },
  {
    title: '患者名称',
    dataIndex: 'patientName',
    key: 'patientName',
    slots: { customRender: 'patientName' }
  },
  {
    title: '医生名称',
    dataIndex: 'doctorName',
    key: 'doctorName',
    slots: { customRender: 'doctorName' }
  },
  {
    title: '预病历ID',
    dataIndex: 'advanceMedicalRecordId',
    key: 'advanceMedicalRecordId'
  },
  {
    title: '预病历状态',
    dataIndex: 'recordState',
    key: 'recordState',
    customRender: ({ text }) => {
      // 0：待确认 1：已确认 2:驳回 3:已失效
      // return text === 0 ? '待确认' : text === 1 ? '已确认' : text === 2 ? '驳回' : '已失效'
      const typeMap = {
        0: '待医生确认',
        1: '医生已确认',
        2: '医生已驳回',
        3: '已失效'
      }
      return typeMap[text] || '未知类型'
    }
  },

  {
    title: '操作',
    dataIndex: 'handle',
    key: 'handle',
    slots: { customRender: 'handle' }
  }
]

// 复诊表单
export const columnsToFollowUpVisit = [
  {
    title: '创建复诊时间',
    key: 'createTime',
    dataIndex: 'createTime',
    width: 120
  },
  {
    title: '设置人姓名',
    key: 'setterName',
    dataIndex: 'setterName',
    width: 80,
    slots: { customRender: 'doctorName' }
  },
  {
    title: '设置来源',
    key: 'source',
    dataIndex: 'source',
    width: 80
  },
  {
    title: '复诊日期',
    key: 'reserveDate',
    dataIndex: 'reserveDate',
    width: 100
  },
  {
    title: '状态',
    key: 'status',
    dataIndex: 'status',
    width: 100
  },
  {
    title: '已触达方式',
    key: 'touchWays',
    dataIndex: 'touchWays',
    width: 100,
    customRender: ({ text }) => {
      return text ? text : '-'
    }
  },
  {
    title: '操作',
    key: 'handle',
    fixed: 'right',
    width: 100,
    slots: {
      customRender: 'handle'
    }
  }
]

// 随访表单
export const columnsToVisit = [
  {
    title: '推送时间',
    key: 'pushTime',
    dataIndex: 'pushTime',
    width: 180
  },
  {
    title: '随访类型',
    key: 'followupBusinessTypeName',
    dataIndex: 'followupBusinessTypeName',
    width: 100
  },
  {
    title: '随访次数',
    key: 'followupTimes',
    dataIndex: 'followupTimes',
    width: 100,
    customRender: ({ text }) => {
      return text ? `第${text}次` : '-'
    }
  },
  {
    title: '随访状态',
    key: 'status',
    width: 150,
    dataIndex: 'status'
  },
  {
    title: '操作',
    key: 'handle',
    fixed: 'right',
    width: 100,
    slots: {
      customRender: 'handleVisit'
    }
  }
]

// 平台表单
export const columnsToPlatform = [
  {
    title: '类型',
    key: 'platformTypeName',
    dataIndex: 'platformTypeName',
    width: 180
  },
  {
    title: '状态',
    key: 'status',
    dataIndex: 'status',
    width: 100
  },
  {
    title: '操作',
    key: 'platformOption',
    fixed: 'right',
    width: 100,
    slots: {
      customRender: 'platformOption'
    }
  }
]
